import { render, staticRenderFns } from "./BedbuilderOptionModal.vue?vue&type=template&id=7cf1841b&"
import script from "./BedbuilderOptionModal.vue?vue&type=script&lang=js&"
export * from "./BedbuilderOptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconDownArrow: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconDownArrow.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
